import dynamic from "next/dynamic";
import React, { Suspense } from "react";

const PopularSearches = dynamic(() => import("./PopularSearches"), {
  suspense: true,
});

const PopularCities = dynamic(() => import("./PopularCities"), {
  suspense: true,
});

const ContactUs = dynamic(() => import("./ContactUs"), {
  suspense: true,
});

const UsefulLinks = dynamic(() => import("./UsefulLinks"), {
  suspense: true,
});

const Credit = dynamic(() => import("./Credit"), {
  suspense: true,
});

export const Footer = () => {
  return (
    <footer className="bg-primary footer text-base">
      <div className="container mx-auto px-5 md:px-0">
        <Suspense fallback={<></>}>
          <div className="flex flex-col md:flex-row justify-center items-center md:justify-start md:items-start gap-10 py-5">
            <ContactUs />
            <PopularSearches />
            <PopularCities />
            <UsefulLinks />
          </div>
          <Credit />
        </Suspense>
      </div>
    </footer>
  );
};
export default Footer;
